import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, writeBatch } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBym3AalKx2Dv0TzVbj36S9VreUokrqq-8",
    authDomain: "tribzz.firebaseapp.com",
    projectId: "tribzz",
    storageBucket: "tribzz.firebasestorage.app",
    messagingSenderId: "97702830414",
    appId: "1:97702830414:web:531a6056e5b03894cafe1f",
    measurementId: "G-3WPS7G3FDR"
  };

// Initialize primary app (for logged-in admin session)
const firebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

// Initialize secondary app for creating users without affecting admin login
const secondaryApp =
  getApps().find(app => app.name === "SECONDARY") ||
  initializeApp(firebaseConfig, "SECONDARY");
const secondaryAuth = getAuth(secondaryApp);

export { firebaseApp, auth, db, writeBatch, storage, secondaryAuth };